/**
 * Grupo "Ferramentas" da toolbar da mesa (E37.F2; extraído do ContestedToolbar // ux-neutrality:allow doc-comment
 * na E47.F3, quando o arquivo passou do teto de 400 linhas). // ux-neutrality:allow doc-comment
 * // ux-neutrality:allow doc-comment
 * Só aparece no modo Comparar — é onde se desenha (a mesa Fabric apenas exibe). // ux-neutrality:allow doc-comment
 */
import { ArrowUpRight, Check, Circle, Trash2 } from 'lucide-react';
import { ptBR } from '@/i18n/pt-BR';
import { ANNOTATION_COLOR_HEX, type AnnotationColor } from '@/lib/mesa_annotations';
import type { AnnotationUiState } from './AnnotationTools';
import { ToolBtn } from './ToolBtn';

export interface ToolsGroupProps {
  annotationUi: AnnotationUiState;
  /** testId prefix para o grupo de overflow. */
  prefix?: string;
  /**
   * A seleção é uma sugestão da análise preliminar (E47.F3)? Nesse caso aparece
   * "Assumir como minha" (só então ela pode entrar no laudo) e o apagar vira
   * "Descartar sugestão".
   */
  selectedIsTriagem: boolean;
  onAdotar: (id: string) => void;
}

export function ToolsGroup({
  annotationUi,
  selectedIsTriagem,
  onAdotar,
  prefix = '',
}: ToolsGroupProps): JSX.Element {
  return (
    <div className="toolbar-group" role="group" aria-label={ptBR.workspaceCaso.toolsGroupLabel}>
      <ToolBtn
        testId={`${prefix}annotate-arrow`}
        icon={<ArrowUpRight className="toolbar-icon" />}
        label={ptBR.workspaceCaso.annotateArrow}
        hint={ptBR.workspaceCaso.annotateGestureTitle}
        pressed={annotationUi.drawTool === 'arrow'}
        onClick={() => annotationUi.setTool('arrow')}
      />
      <ToolBtn
        testId={`${prefix}annotate-circle`}
        icon={<Circle className="toolbar-icon" />}
        label={ptBR.workspaceCaso.annotateCircle}
        hint={ptBR.workspaceCaso.annotateGestureTitle}
        pressed={annotationUi.drawTool === 'circle'}
        onClick={() => annotationUi.setTool('circle')}
      />
      {(Object.keys(ANNOTATION_COLOR_HEX) as AnnotationColor[]).map((color) => (
        <button
          key={color}
          type="button"
          className="toolbar-btn annotation-color"
          data-testid={`${prefix}annotate-color-${color}`}
          aria-pressed={annotationUi.drawColor === color}
          aria-label={
            color === 'green'
              ? ptBR.workspaceCaso.annotateColorGreen
              : color === 'amber'
                ? ptBR.workspaceCaso.annotateColorAmber
                : ptBR.workspaceCaso.annotateColorRed
          }
          style={{ '--annotation-color': ANNOTATION_COLOR_HEX[color] } as React.CSSProperties}
          onClick={() => annotationUi.setColor(color)}
        />
      ))}
      {selectedIsTriagem && annotationUi.selectedId !== null && (
        <ToolBtn
          testId={`${prefix}triagem-adopt`}
          icon={<Check className="toolbar-icon" />}
          label={ptBR.workspaceCaso.triagemAdopt}
          hint={ptBR.workspaceCaso.triagemAdoptTitle}
          onClick={() => onAdotar(annotationUi.selectedId as string)}
        />
      )}
      <ToolBtn
        testId={`${prefix}annotate-delete`}
        icon={<Trash2 className="toolbar-icon" />}
        label={
          selectedIsTriagem ? ptBR.workspaceCaso.triagemDiscard : ptBR.workspaceCaso.annotateDelete
        }
        disabled={annotationUi.selectedId === null}
        onClick={() => annotationUi.deleteSelected()}
      />
    </div>
  );
}
